import type {
  ConfigurationModuleResourceReadBffV2Api,
  ConfigurationModuleSnapshotResourceParameterSetSnapshotReadBffV2Api,
} from '@ingenico/api-sdk-device-management-private-v2';
import type { FGBuildByTemplateWithSmartFields } from '@ingenico/react-configuration-generator';
import type {
  ConfigurationModule,
  ModuleInitParams,
  TemplateDetails,
  TemplateInfoFromList,
} from '@ingenico/react-form-builder';
import { FGLanguagesEnum } from '@ingenico/react-form-generator';
import { toString } from 'lodash-es';
import {
  createFieldMappingByContainerId,
  createFieldsValuesMapping,
  getAllSmartFieldsFromDirtyStateMappingValue,
  transformTemplatesForFormGeneratorWithCategories,
  transformTemplatesForFormGeneratorWithCategoriesForVirtualDevice,
} from '../../../components/parameter-module/parameter-module-tab/ParameterModuleTab.util';
import type { TemplateValues } from '../../models/configurationModules.model';
import type { TemplateDetailedResource } from '../../models/templateResource.model';

export function mapTemplatesToFGBuildModel(
  template: TemplateDetailedResource,
  templateValues: TemplateValues,
  smartFieldPrefix: string,
  locale = FGLanguagesEnum.Us,
): FGBuildByTemplateWithSmartFields {
  // Set all fields in the selected template without overriden values
  const fieldsMapping = createFieldMappingByContainerId({ [template.id]: template });

  // The value defined for every fields
  const valuesMapping = createFieldsValuesMapping(fieldsMapping, templateValues);

  const allSmartFields = getAllSmartFieldsFromDirtyStateMappingValue(valuesMapping);

  const formBuilderConfig = transformTemplatesForFormGeneratorWithCategories({
    containers: template.parameter.containers,
    fieldsMapping: fieldsMapping?.[template.id] ?? {},
    valuesMapping,
    locale,
    selectedTemplateId: template.id,
    smartFields: allSmartFields,
    smartFieldPrefix,
  });
  return {
    name: toString(template.name),
    description: toString(template.description),
    config: formBuilderConfig,
    smartFieldsId: Object.keys(allSmartFields[template.id] ?? []),
  };
}
export function mapTemplatesToFGBuildModelForVirtualDevice(
  template: TemplateDetailedResource,
  templateValues: TemplateValues,
  smartFieldPrefix: string,
  locale = FGLanguagesEnum.Us,
): FGBuildByTemplateWithSmartFields {
  // Set all fields in the selected template without overriden values
  const fieldsMapping = createFieldMappingByContainerId({ [template.id]: template });

  // The value defined for every fields
  const valuesMapping = createFieldsValuesMapping(fieldsMapping, templateValues);

  const allSmartFields = getAllSmartFieldsFromDirtyStateMappingValue(valuesMapping);

  const formBuilderConfig = transformTemplatesForFormGeneratorWithCategoriesForVirtualDevice({
    containers: template.parameter.containers,
    fieldsMapping: fieldsMapping?.[template.id] ?? {},
    valuesMapping,
    locale,
    selectedTemplateId: template.id,
    smartFields: allSmartFields,
    smartFieldPrefix,
  });

  return {
    name: toString(template.name),
    description: toString(template.description),
    config: formBuilderConfig,
    smartFieldsId: Object.keys(allSmartFields[template.id] ?? []),
  };
}

export function mapTemplatesToFormBuilder(
  template: TemplateDetailedResource,
  configModule:
    | ConfigurationModuleSnapshotResourceParameterSetSnapshotReadBffV2Api
    | ConfigurationModuleResourceReadBffV2Api
    | undefined,
): ModuleInitParams {
  return {
    configModule: configModule as ConfigurationModule,
    mode: 'module',
    templateList: [template] as TemplateInfoFromList[],
    templateToDisplay: template as unknown as TemplateDetails,
  };
}
